import React, { memo } from 'react'
import styles from '../styles.module.scss'

interface FlowerHeaderProps {
  canContinue: boolean
  selectedCount: number
  minRequired: number
  onContinue: () => void
  isSaving?: boolean
}

/* eslint-disable react/prop-types */
const FlowerHeader = memo<FlowerHeaderProps>(({ canContinue, selectedCount, onContinue, isSaving = false }) => (
  <div className={styles.flowerleftSection}>
    <div className={styles.textContent}>
      <div className={styles.titleContainer}>
        <h1 id="flower-selection-title" className={styles.title}>
          Select the flowers that make you swoon.
        </h1>
        <p className={styles.flowerSubtitle}>Pick 3 or more to find a collection that matches your style.</p>
      </div>
    </div>
    {/* Mobile-only Continue Button and Subtitle */}
    <div className={styles.continueMobileContainer}>
      {selectedCount <= 3 && <p className={styles.subtitleMobile}>Choose 3 or more images</p>}
      <button
        className={
          `${styles.continueButtonMobile} ` +
          (isSaving ? styles.saving : selectedCount >= 3 ? styles.validSelection : '')
        }
        onClick={onContinue}
        disabled={!canContinue || isSaving}
        aria-disabled={!canContinue || isSaving}
      >
        {isSaving ? <span className={styles.savingText}>NEXT</span> : 'NEXT'}
      </button>
    </div>
  </div>
))

FlowerHeader.displayName = 'FlowerHeader'

export default FlowerHeader
